module.exports = __webpack_public_path__ + "img/scatter_freespin.19328f39.png";